import * as React from 'react';
import { st, classes } from '../FileUpload.st.css';
import FileUploadIndicator from './FileUploadIndicator';
const File = ({ file, onDeleteClick, deleteText, dataHook, focusFile = false, ...rest }) => {
    const a11yProps = focusFile ? { tabIndex: 0 } : [];
    return (React.createElement("div", { className: st(classes.fileContainer, {
            error: file.state === 'error',
        }), ...a11yProps, "aria-describedby": rest['aria-describedby'] },
        React.createElement("div", { "data-hook": dataHook, className: classes.file, title: file.file.name }, file.file.name),
        React.createElement("div", { className: classes.fileUploadIndicator },
            React.createElement(FileUploadIndicator, { state: file.state, onDeleteClick: onDeleteClick, deleteText: deleteText }))));
};
export default File;
//# sourceMappingURL=File.js.map